import axios from 'axios';
import { tokenUtils } from '../utils/tokenUtils';

class CommentsService {
  constructor() {
    this.apiUrl = process.env.REACT_APP_API_URL;
  }

  getAuthHeaders() {
    const token = tokenUtils.get();
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  // Get comments for a course
  async getComments(videoId, courseId) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/Course/${courseId}/comments`,
        { headers: this.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching comments:', error);
      throw error;
    }
  }

  // Add a new comment
  async addComment(videoId, courseId, text) {
    try {
      const usuarioConCedula = JSON.parse(localStorage.getItem("usuarioConCedula"));
      const userId = usuarioConCedula?.id;
      
      if (!userId) {
        throw new Error('Usuario no autenticado');
      }
      
      const response = await axios.post(
        `${this.apiUrl}/Course/${courseId}/comments`,
        {
          content: text,  // Changed from 'text' to 'content'
          author: userId
        },
        { headers: this.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error adding comment:', error);
      throw error;
    }
  }

  // Get replies for a comment
  async getReplies(commentId, courseId) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/Commentary/comment/${commentId}/replies?courseId=${courseId}`,
        { headers: this.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching replies:', error);
      throw error;
    }
  }

  // Add a reply to a comment
  async addReply(commentId, courseId, text) {
    try {
      const usuarioConCedula = JSON.parse(localStorage.getItem("usuarioConCedula"));
      const userId = usuarioConCedula?.id;
      
      if (!userId) {
        throw new Error('Usuario no autenticado');
      }
      
      const response = await axios.post(
        `${this.apiUrl}/Commentary/comment/${commentId}/reply?courseId=${courseId}`,
        {
          content: text,  // Changed from 'text' to 'content'
          parentid: commentId,  // Added parentid field
          author: userId
        },
        { headers: this.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error adding reply:', error);
      throw error;
    }
  }

  // Like a comment
  async likeComment(commentId, courseId, videoId) {
    try {
      const usuarioConCedula = JSON.parse(localStorage.getItem("usuarioConCedula"));
      const userId = usuarioConCedula?.id;
      
      if (!userId) {
        throw new Error('Usuario no autenticado');
      }
      
      const payload = {
        userId
      };

      if (courseId) {
        payload.courseId = courseId;
      }

      if (videoId) {
        payload.videoId = videoId;
      }

      const response = await axios.post(
        `${this.apiUrl}/Commentary/comment/${commentId}/like`,
        payload,
        { headers: this.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error liking comment:', error);
      throw error;
    }
  }

  // Unlike a comment
  async unlikeComment(commentId, courseId, videoId) {
    try {
      const usuarioConCedula = JSON.parse(localStorage.getItem("usuarioConCedula"));
      const userId = usuarioConCedula?.id;
      
      if (!userId) {
        throw new Error('Usuario no autenticado');
      }

      const params = new URLSearchParams();
      params.append('userId', userId);
      if (courseId) {
        params.append('courseId', courseId);
      }
      if (videoId) {
        params.append('videoId', videoId);
      }

      const response = await axios.delete(
        `${this.apiUrl}/Commentary/comment/${commentId}/like?${params.toString()}`,
        { headers: this.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error unliking comment:', error);
      throw error;
    }
  }

  async getCommentLikes(commentId, courseId, videoId) {
    try {
      const params = new URLSearchParams();
      if (courseId) {
        params.append('courseId', courseId);
      }
      if (videoId) {
        params.append('videoId', videoId);
      }

      const query = params.toString();
      const url = query
        ? `${this.apiUrl}/Commentary/comment/${commentId}/like?${query}`
        : `${this.apiUrl}/Commentary/comment/${commentId}/like`;

      const response = await axios.get(url, { headers: this.getAuthHeaders() });
      return response.data;
    } catch (error) {
      console.error('Error fetching comment likes:', error);
      throw error;
    }
  }
}

const commentsService = new CommentsService();
export default commentsService; 